import React from "react";
import { Container } from "react-bootstrap";

export const Assets: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                Assets......
            </Container>
        </React.Fragment>
    );
}